// extracted by mini-css-extract-plugin
module.exports = {"product":"product_product__1_-HO"};